// Debug utility for controlling console output
class DebugLogger {
  constructor() {
    // Check if debug mode is enabled via localStorage or URL parameter
    this.isDebugMode = this.checkDebugMode();
  }

  checkDebugMode() {
    // Check URL parameter first
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('debug') === 'true') {
      localStorage.setItem('debug_mode', 'true');
      return true;
    }
    if (urlParams.get('debug') === 'false') {
      localStorage.removeItem('debug_mode');
      return false;
    }
    
    // Check localStorage
    return localStorage.getItem('debug_mode') === 'true';
  }

  log(message, ...args) {
    if (this.isDebugMode) {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  }

  warn(message, ...args) {
    if (this.isDebugMode) {
      console.warn(`[DEBUG] ${message}`, ...args);
    }
  }

  error(message, ...args) {
    // Always show errors, but prefix with debug if in debug mode
    if (this.isDebugMode) {
      console.error(`[DEBUG] ${message}`, ...args);
    } else {
      console.error(message, ...args);
    }
  }

  info(message, ...args) {
    if (this.isDebugMode) {
      console.info(`[DEBUG] ${message}`, ...args);
    }
  }

  // Method to toggle debug mode
  toggle() {
    this.isDebugMode = !this.isDebugMode;
    if (this.isDebugMode) {
      localStorage.setItem('debug_mode', 'true');
      console.log('Debug mode enabled. Add ?debug=false to URL to disable.');
    } else {
      localStorage.removeItem('debug_mode');
      console.log('Debug mode disabled. Add ?debug=true to URL to enable.');
    }
  }

  // Method to check if debug is enabled
  isEnabled() {
    return this.isDebugMode;
  }
}

// Create singleton instance
const debugLogger = new DebugLogger();

// Make it available globally for easy access
window.debug = debugLogger;

export default debugLogger;
